import { createAction, props } from '@ngrx/store';
import { NotificationColor } from './components/notification.view-model';

const feature = '[CXB Notification]';

export const setCxbNotification = createAction(`${feature} Set notification`, props<{ message: string; color: NotificationColor }>());
export const setCxbSuccessNotification = createAction(`${feature} Set success notification`, props<{ message: string }>());
export const setCxbErrorNotification = createAction(`${feature} Set error notification`, props<{ message: string }>());
